import { render } from "./user-list.vue?vue&type=template&id=4eb94bde"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__